// extracted by mini-css-extract-plugin
export var danger = "_r-6";
export var lightPink = "_r-a";
export var medium = "_r-j";
export var nearSquare = "_r-m";
export var neutralBlue = "_r-8";
export var neutralYellow = "_r-7";
export var noCapitalize = "_r-1";
export var normal = "_r-2";
export var pill = "_r-0";
export var primary = "_r-3";
export var primaryLight = "_r-4";
export var shadow = "_r-n";
export var small = "_r-k";
export var solidBlack = "_r-i";
export var solidGreen = "_r-d";
export var solidLightBlue = "_r-f";
export var solidNavy = "_r-e";
export var solidOrange = "_r-h";
export var solidPink = "_r-g";
export var solidRed = "_r-b";
export var solidWhite = "_r-9";
export var solidYellow = "_r-c";
export var success = "_r-5";
export var xsmall = "_r-l";